// AUTO-GENERATED from Phase2_20Cities_Website_Plan.xlsx (Dallas tab).
// Source of truth for all Dallas pillar pages.

export type Lane = "GBP" | "Organic";
export type PageType = "Home" | "City Hub" | "Money Pillar" | "Vertical Pillar";

export type DallasPage = {
  pageType: PageType;
  url: string;
  slug: string | null;
  pillar: string;
  primaryKeyword: string;
  h1: string;
  secondaryKeywords: string[];
  faqQuestions: string[];
  lane: Lane;
  schema: string[];
  clusterSize: number;
  natVol: number;
  cpc: number;
};

export const dallasPages: DallasPage[] = [
  {
    "pageType": "Home",
    "url": "/",
    "slug": null,
    "pillar": "Brand / City",
    "primaryKeyword": "business loans dallas",
    "h1": "Business Loans & Funding in Dallas, TX",
    "secondaryKeywords": [
      "small business loans dallas",
      "business funding dallas",
      "business line of credit dallas"
    ],
    "faqQuestions": [
      "how to get a business loan in dallas",
      "best business lenders dallas"
    ],
    "lane": "Organic",
    "schema": [
      "Organization",
      "WebSite",
      "LocalBusiness"
    ],
    "clusterSize": 1,
    "natVol": 500000,
    "cpc": 446.0
  },
  {
    "pageType": "City Hub",
    "url": "/dallas/",
    "slug": null,
    "pillar": "City Hub",
    "primaryKeyword": "business loans dallas",
    "h1": "Small Business Loans in Dallas, TX \u2014 All Programs",
    "secondaryKeywords": [
      "business loans dallas",
      "sba loans dallas",
      "working capital dallas"
    ],
    "faqQuestions": [
      "what business loans are available in dallas"
    ],
    "lane": "Organic",
    "schema": [
      "CollectionPage",
      "BreadcrumbList"
    ],
    "clusterSize": 1,
    "natVol": 500000,
    "cpc": 446.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/sba-loans/",
    "slug": "sba-loans",
    "pillar": "Sba Loans",
    "primaryKeyword": "sba loans dallas",
    "h1": "Sba Loans in Dallas, TX",
    "secondaryKeywords": [
      "sba lenders",
      "sba loan lenders",
      "sba business loan",
      "sba loans for small business",
      "sba 7 a lender",
      "sba business startup loan",
      "sba loans for startup companies",
      "startup loan sba"
    ],
    "faqQuestions": [
      "paying sba loan",
      "sba",
      "sba loan calculator",
      "sba loan calc",
      "apply for sba loan",
      "sba loan applications"
    ],
    "lane": "GBP",
    "schema": [
      "Service",
      "FAQPage",
      "LocalBusiness"
    ],
    "clusterSize": 1839,
    "natVol": 500000,
    "cpc": 15.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/sba-7a-loan/",
    "slug": "sba-7a-loan",
    "pillar": "Sba 7a Loan",
    "primaryKeyword": "sba 7a loan dallas",
    "h1": "Sba 7a Loan in Dallas, TX",
    "secondaryKeywords": [
      "small business administration 7a loan",
      "sba 7a loan lenders",
      "sba 7a",
      "sba 7a business loan",
      "sba 7a loan requirements",
      "sba 7a loan qualifications",
      "sba 7a loan guidelines",
      "sba 7a loan criteria"
    ],
    "faqQuestions": [
      "sba 7a lenders",
      "7a small business loan",
      "7a business loan",
      "7a loan",
      "7a lenders",
      "loan 7a"
    ],
    "lane": "GBP",
    "schema": [
      "Service",
      "FAQPage",
      "LocalBusiness"
    ],
    "clusterSize": 269,
    "natVol": 50000,
    "cpc": 15.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/business-line-of-credit/",
    "slug": "business-line-of-credit",
    "pillar": "Business Line Of Credit",
    "primaryKeyword": "business line of credit dallas",
    "h1": "Business Line Of Credit in Dallas, TX",
    "secondaryKeywords": [
      "line of credit business loans",
      "business line of credit lenders",
      "business credit line of credit",
      "business credit line loan",
      "business credit line",
      "business line of credit companies",
      "best business line of credit",
      "unsecured business line of credit"
    ],
    "faqQuestions": [
      "line of credit loan for small business",
      "small business line credit",
      "small business line of credit lenders",
      "bank of america business line of credit",
      "bluevine business line of credit",
      "business line"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 1079,
    "natVol": 50000,
    "cpc": 141.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/working-capital-loans/",
    "slug": "working-capital-loans",
    "pillar": "Working Capital Loans",
    "primaryKeyword": "working capital loans dallas",
    "h1": "Working Capital Loans in Dallas, TX",
    "secondaryKeywords": [
      "capital venture firm",
      "business working capital loans",
      "working capital loans for small business",
      "working capital for small business loan",
      "small business operating capital loans",
      "working capital loans",
      "working capital lenders",
      "operating capital loan"
    ],
    "faqQuestions": [
      "sba working capital loan",
      "sba loan for working capital",
      "paypal working capital",
      "paypal working capital loan",
      "paypal capital working loan",
      "capital loan"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 500,
    "natVol": 50000,
    "cpc": 106.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/small-business-loans/",
    "slug": "small-business-loans",
    "pillar": "Small Business Loans",
    "primaryKeyword": "small business loans dallas",
    "h1": "Small Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "small business loans"
    ],
    "faqQuestions": [],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 0,
    "natVol": 0,
    "cpc": 32.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/short-term-business-loans/",
    "slug": "short-term-business-loans",
    "pillar": "Short Term Business Loans",
    "primaryKeyword": "short term business loans dallas",
    "h1": "Short Term Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "short term business loans",
      "short term business funding",
      "short term business lending",
      "short term business loan lenders",
      "short term corporate loans",
      "small business term loans",
      "term loans for small businesses",
      "term small business loan"
    ],
    "faqQuestions": [
      "long term business loans",
      "long term business lending",
      "short term small business loan",
      "business term loan lenders",
      "long term small business loan",
      "chase business term loan"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 185,
    "natVol": 50000,
    "cpc": 154.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/merchant-cash-advance/",
    "slug": "merchant-cash-advance",
    "pillar": "Merchant Cash Advance",
    "primaryKeyword": "merchant cash advance dallas",
    "h1": "Merchant Cash Advance in Dallas, TX",
    "secondaryKeywords": [
      "small business merchant cash advance",
      "business cash advance",
      "cash advance for business owners",
      "merchant cash advance",
      "merchant advance",
      "mca advance",
      "mca cash",
      "advance merchant"
    ],
    "faqQuestions": [
      "advance business loan",
      "small business cash flow loan",
      "cash loan business",
      "business merchant cash advance",
      "business merchant loans",
      "business cash advance loans"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 291,
    "natVol": 5000,
    "cpc": 37.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/unsecured-business-loans/",
    "slug": "unsecured-business-loans",
    "pillar": "Unsecured Business Loans",
    "primaryKeyword": "unsecured business loans dallas",
    "h1": "Unsecured Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "unsecured business lending",
      "unsecured company loans",
      "unsecured business loan lenders",
      "unsecured corporate loans",
      "best unsecured business loans",
      "unsecured small business loans",
      "unsecured loans small business",
      "unsecured small business lending"
    ],
    "faqQuestions": [
      "startup unsecured business loans",
      "unsecured startup business loans",
      "unsecured start up business loans",
      "unsecured loans for business start up",
      "unsecured finance",
      "quick unsecured business loans"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 98,
    "natVol": 5000,
    "cpc": 80.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/startup-business-loans/",
    "slug": "startup-business-loans",
    "pillar": "Startup Business Loans",
    "primaryKeyword": "startup business loans dallas",
    "h1": "Startup Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "small business startup loans",
      "small business loans for startup companies",
      "small business loan for startup business",
      "small business startup lenders",
      "loan small business startup",
      "small business startup financing",
      "business loan for startup company",
      "startup business loans"
    ],
    "faqQuestions": [
      "startup lending",
      "startup funds for small business",
      "venture backed startup",
      "startup finance",
      "new business startup loan",
      "startup business loans for women"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 343,
    "natVol": 5000,
    "cpc": 45.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/business-acquisition-loans/",
    "slug": "business-acquisition-loans",
    "pillar": "Business Acquisition Loans",
    "primaryKeyword": "business acquisition loans dallas",
    "h1": "Business Acquisition Loans in Dallas, TX",
    "secondaryKeywords": [
      "business acquisition lenders",
      "business acquisition loans",
      "acquisition loan",
      "acquisition lending",
      "small business acquisition loan",
      "acquisition of funds",
      "bridge loan for business acquisition",
      "franchise acquisition financing"
    ],
    "faqQuestions": [
      "private lenders for business acquisition",
      "100 business acquisition financing",
      "business acquisition loan lenders",
      "hard money lenders for business acquisition",
      "hard money business acquisition loans",
      "laundromat acquisition financing"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 44,
    "natVol": 5000,
    "cpc": 22.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/accounts-receivable-financing/",
    "slug": "accounts-receivable-financing",
    "pillar": "Accounts Receivable Financing",
    "primaryKeyword": "accounts receivable financing dallas",
    "h1": "Accounts Receivable Financing in Dallas, TX",
    "secondaryKeywords": [
      "accounts receivable factoring",
      "factoring accounts receivable financing",
      "factoring in accounts receivable",
      "accounts receivable factoring loans",
      "accounts receivable financing companies",
      "receivable financing companies",
      "accounts receivable funding",
      "accounts receivable loans"
    ],
    "faqQuestions": [
      "medical accounts receivable factoring",
      "healthcare accounts receivable factoring",
      "best accounts receivable factoring companies",
      "best accounts receivable financing companies",
      "best accounts receivable financing company",
      "loan against accounts receivable"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 82,
    "natVol": 5000,
    "cpc": 88.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/invoice-factoring/",
    "slug": "invoice-factoring",
    "pillar": "Invoice Factoring",
    "primaryKeyword": "invoice factoring dallas",
    "h1": "Invoice Factoring in Dallas, TX",
    "secondaryKeywords": [
      "factoring company trucking",
      "factoring companies for trucking companies",
      "factoring companies for trucking industry",
      "trucking company factoring companies",
      "invoice factoring",
      "factoring company",
      "business factoring",
      "factoring co"
    ],
    "faqQuestions": [
      "factoring your receivables",
      "factoring loans receivable",
      "factoring trade receivables",
      "receivable financing factoring",
      "business invoice financing",
      "invoice financing business"
    ],
    "lane": "GBP",
    "schema": [
      "Service",
      "FAQPage",
      "LocalBusiness"
    ],
    "clusterSize": 540,
    "natVol": 5000,
    "cpc": 73.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/revenue-based-financing/",
    "slug": "revenue-based-financing",
    "pillar": "Revenue Based Financing",
    "primaryKeyword": "revenue based financing dallas",
    "h1": "Revenue Based Financing in Dallas, TX",
    "secondaryKeywords": [
      "revenue based funding",
      "asset based lending",
      "asset based lending loan",
      "asset based loan",
      "business funding based on revenue",
      "revenue based loans",
      "revenue based lending",
      "revenue based lender"
    ],
    "faqQuestions": [
      "revenue loans",
      "revenue lending",
      "asset based business loan",
      "asset based business lending",
      "business asset based loan",
      "revenue financing"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 158,
    "natVol": 5000,
    "cpc": 72.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/same-day-business-loans/",
    "slug": "same-day-business-loans",
    "pillar": "Same Day Business Loans",
    "primaryKeyword": "same day business loans dallas",
    "h1": "Same Day Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "$500 payday loans online same day",
      "same day business loans",
      "same day business funding",
      "business funding same day",
      "same day business lending",
      "loans next day",
      "next day online loans",
      "next day lending"
    ],
    "faqQuestions": [
      "same day loan instant",
      "same day payday lenders",
      "same day emergency loan",
      "business loans same day funding",
      "next day business loans",
      "same day small business loans"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 71,
    "natVol": 50000,
    "cpc": 119.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/business-lenders-near-me/",
    "slug": "business-lenders-near-me",
    "pillar": "Business Lenders Near Me",
    "primaryKeyword": "business lenders near me dallas",
    "h1": "Business Lenders Near Me in Dallas, TX",
    "secondaryKeywords": [
      "best business lenders",
      "online business lenders",
      "online business loan lenders",
      "business loan lenders online",
      "top business lenders",
      "online lenders for small business",
      "best small business lenders",
      "best lenders for small business loans"
    ],
    "faqQuestions": [
      "micro lenders for small business",
      "semi truck lenders",
      "hard money lenders near me",
      "loans from private lenders",
      "alternative business lenders",
      "best online business lenders"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 136,
    "natVol": 50000,
    "cpc": 33.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/business-loan-broker/",
    "slug": "business-loan-broker",
    "pillar": "Business Loan Broker",
    "primaryKeyword": "business loan broker dallas",
    "h1": "Business Loan Broker in Dallas, TX",
    "secondaryKeywords": [
      "small business loan broker",
      "small business lending broker",
      "sba loan broker",
      "sba broker",
      "business loan broker",
      "business lending broker",
      "hard money lending broker",
      "business loan broker near me"
    ],
    "faqQuestions": [
      "mortgage broker startup",
      "sba loan broker near me",
      "best loan broker",
      "business finance broker",
      "sba broker near me",
      "mortgage broker franchise opportunities"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 34,
    "natVol": 500,
    "cpc": 19.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/commercial-loan-broker/",
    "slug": "commercial-loan-broker",
    "pillar": "Commercial Loan Broker",
    "primaryKeyword": "commercial loan broker dallas",
    "h1": "Commercial Loan Broker in Dallas, TX",
    "secondaryKeywords": [
      "commercial mortgage loan broker",
      "commercial property loan broker",
      "commercial mortgage broker near me",
      "commercial property mortgage broker",
      "commercial loan broker",
      "mortgage broker for commercial property",
      "mortgage broker commercial",
      "commercial finance broker"
    ],
    "faqQuestions": [
      "commercial loan broker franchise",
      "commercial finance broker franchise",
      "commercial loan broker websites",
      "commercial loan mortgage broker",
      "commercial hard money broker",
      "eastern union commercial mortgage broker"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 21,
    "natVol": 5000,
    "cpc": 16.0
  },
  {
    "pageType": "Money Pillar",
    "url": "/dallas/equipment-financing/",
    "slug": "equipment-financing",
    "pillar": "Equipment Financing",
    "primaryKeyword": "equipment financing dallas",
    "h1": "Equipment Financing in Dallas, TX",
    "secondaryKeywords": [
      "business equipment financing",
      "equipment financing for business",
      "equipment loan business",
      "equipment financing companies",
      "equipment loan companies",
      "equipment lending companies",
      "small business equipment loan",
      "small business equipment financing"
    ],
    "faqQuestions": [
      "equipment loans",
      "equipment leasing",
      "us bank equipment finance",
      "us bancorp equipment finance",
      "us bank equipment financing",
      "farm equipment financing"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 595,
    "natVol": 5000,
    "cpc": 36.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/dental-practice-loans/",
    "slug": "dental-practice-loans",
    "pillar": "Dental Practice Loans",
    "primaryKeyword": "dental practice loans dallas",
    "h1": "Dental Practice Loans in Dallas, TX",
    "secondaryKeywords": [
      "dental practice financing",
      "dental practice lenders",
      "dental loan",
      "dental office financing",
      "dental business loan",
      "dental business financing",
      "bank of america dental practice loans",
      "sba loan for dental practice"
    ],
    "faqQuestions": [
      "dental loans for dental work",
      "dental care loans",
      "loans for dental care",
      "bank of america dental loans",
      "bank of america dental lending",
      "best dental practice loans"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 72,
    "natVol": 5000,
    "cpc": 58.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/medical-practice-loans/",
    "slug": "medical-practice-loans",
    "pillar": "Medical Practice Loans",
    "primaryKeyword": "medical practice loans dallas",
    "h1": "Medical Practice Loans in Dallas, TX",
    "secondaryKeywords": [
      "physician practice loans",
      "physician practice financing",
      "medical practice loans",
      "medical practice financing",
      "medical practice lending",
      "sba loan for medical practice",
      "veterinary practice loans",
      "practice financing"
    ],
    "faqQuestions": [
      "business loans for medical practice",
      "medical practice acquisition loan",
      "medical office financing",
      "healthcare practice loans",
      "medical office loans",
      "healthcare practice financing"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 40,
    "natVol": 500,
    "cpc": 49.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/restaurant-loans/",
    "slug": "restaurant-loans",
    "pillar": "Restaurant Loans",
    "primaryKeyword": "restaurant loans dallas",
    "h1": "Restaurant Loans in Dallas, TX",
    "secondaryKeywords": [
      "restaurant lending",
      "loans restaurant",
      "restaurant business loans",
      "restaurant business financing",
      "restaurant financing",
      "small business loan for restaurant",
      "new restaurant loans",
      "restaurant financing companies"
    ],
    "faqQuestions": [
      "restaurant start up loans",
      "loan to buy a restaurant",
      "business loan to buy a restaurant",
      "how to get loan for restaurant business",
      "how to get a loan for restaurant business",
      "restaurant loan requirements"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 61,
    "natVol": 500,
    "cpc": 46.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/trucking-business-loans/",
    "slug": "trucking-business-loans",
    "pillar": "Trucking Business Loans",
    "primaryKeyword": "trucking business loans dallas",
    "h1": "Trucking Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "loans for trucking companies",
      "small trucking business loans",
      "trucking company financing",
      "business loan for trucking company",
      "small business loans for trucking companies",
      "start up trucking business loans",
      "owner operator trucking loans",
      "loans to start a trucking company"
    ],
    "faqQuestions": [
      "trucking business start up loans",
      "how to get a trucking business loan",
      "how to get a business loan for a trucking company",
      "best trucking business loans",
      "start up business loans for trucking",
      "trucking start up loans"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 23,
    "natVol": 500,
    "cpc": 31.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/commercial-construction-loan/",
    "slug": "commercial-construction-loan",
    "pillar": "Commercial Construction Loan",
    "primaryKeyword": "commercial construction loan dallas",
    "h1": "Commercial Construction Loan in Dallas, TX",
    "secondaryKeywords": [
      "construction loan for commercial property",
      "commercial construction loan",
      "commercial construction financing",
      "loans for construction companies",
      "business loans for construction companies",
      "construction business loans",
      "construction companies that finance",
      "small business construction loans"
    ],
    "faqQuestions": [
      "construction loans for contractors",
      "financing for construction projects",
      "commercial construction loan rates",
      "business construction loan rates",
      "commercial construction interest rates",
      "commercial construction lending rates"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 99,
    "natVol": 5000,
    "cpc": 27.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/hotel-loans/",
    "slug": "hotel-loans",
    "pillar": "Hotel Loans",
    "primaryKeyword": "hotel loans dallas",
    "h1": "Hotel Loans in Dallas, TX",
    "secondaryKeywords": [
      "loan hotel",
      "hotel financing",
      "hotel business loans",
      "hotel bridge loans",
      "hotel financing options",
      "loan for hotel purchase",
      "loan to buy hotel",
      "hotel loans mortgage"
    ],
    "faqQuestions": [
      "hotel franchise financing",
      "western alliance hotel franchise finance",
      "msme loan for hotel",
      "hotel motel loans",
      "business loan to buy hotel",
      "msme loan for hotel business"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 20,
    "natVol": 500,
    "cpc": 45.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/salon-business-loans/",
    "slug": "salon-business-loans",
    "pillar": "Salon Business Loans",
    "primaryKeyword": "salon business loans dallas",
    "h1": "Salon Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "business loan for beauty salon",
      "beauty salon loan",
      "loan beauty salon",
      "hair salon financing",
      "beauty salon financing",
      "nail salon financing",
      "salon loans",
      "hair salon loans"
    ],
    "faqQuestions": [
      "loans hair salon",
      "nail salon small business loans",
      "small business loan for beauty salon"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 16,
    "natVol": 500,
    "cpc": 39.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/retail-business-loans/",
    "slug": "retail-business-loans",
    "pillar": "Retail Business Loans",
    "primaryKeyword": "retail business loans dallas",
    "h1": "Retail Business Loans in Dallas, TX",
    "secondaryKeywords": [
      "business loans for retail",
      "retail store financing",
      "business loan for retail store",
      "retail loan",
      "retail store loan",
      "retail shop loan",
      "loan for retail store",
      "retail loan calculator"
    ],
    "faqQuestions": [
      "online retail finance",
      "truist retail loans",
      "government loan for retail business",
      "loan for retail traders",
      "loan for small retail shop",
      "retail finance loan"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 22,
    "natVol": 500,
    "cpc": 32.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/auto-repair-shop-financing/",
    "slug": "auto-repair-shop-financing",
    "pillar": "Auto Repair Shop Financing",
    "primaryKeyword": "auto repair shop financing dallas",
    "h1": "Auto Repair Shop Financing in Dallas, TX",
    "secondaryKeywords": [
      "bank of america business auto loan",
      "auto repair shop financing",
      "auto repair shop with financing",
      "business auto loans without personal guarantee",
      "business auto loan no personal guarantee",
      "ally bank business auto loan",
      "navy federal business auto loan",
      "chase business auto loan"
    ],
    "faqQuestions": [
      "auto shop loans",
      "business auto loan with personal guarantee",
      "bank of america business auto loan rates",
      "apply for ally business auto loan",
      "bank of america business auto refinance",
      "semi truck repair loan"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 42,
    "natVol": 500000,
    "cpc": 8.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/ecommerce-business-funding/",
    "slug": "ecommerce-business-funding",
    "pillar": "Ecommerce Business Funding",
    "primaryKeyword": "ecommerce business funding dallas",
    "h1": "Ecommerce Business Funding in Dallas, TX",
    "secondaryKeywords": [
      "funding for ecommerce business",
      "ecommerce business loans",
      "loan for ecommerce business",
      "ecommerce loans",
      "ecommerce inventory financing",
      "financing for ecommerce business",
      "ecommerce seller financing",
      "best ecommerce loans"
    ],
    "faqQuestions": [],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 12,
    "natVol": 500,
    "cpc": 70.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/food-truck-financing/",
    "slug": "food-truck-financing",
    "pillar": "Food Truck Financing",
    "primaryKeyword": "food truck financing dallas",
    "h1": "Food Truck Financing in Dallas, TX",
    "secondaryKeywords": [
      "semi truck trailer financing",
      "truck loans",
      "truck lending",
      "food truck financing",
      "food truck loan",
      "loan food truck",
      "food truck loans",
      "financing truck"
    ],
    "faqQuestions": [
      "company truck financing",
      "small business loans for truck drivers",
      "semi truck financing companies",
      "big truck financing",
      "big truck loans",
      "business loans for truck drivers"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 189,
    "natVol": 5000,
    "cpc": 8.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/loan-for-gym-business/",
    "slug": "loan-for-gym-business",
    "pillar": "Loan For Gym Business",
    "primaryKeyword": "loan for gym business dallas",
    "h1": "Loan For Gym Business in Dallas, TX",
    "secondaryKeywords": [
      "gym business loans",
      "gym loans",
      "loan for gym setup",
      "loan for opening a gym"
    ],
    "faqQuestions": [],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 5,
    "natVol": 500,
    "cpc": 19.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/manufacturing-equipment-financing/",
    "slug": "manufacturing-equipment-financing",
    "pillar": "Manufacturing Equipment Financing",
    "primaryKeyword": "manufacturing equipment financing dallas",
    "h1": "Manufacturing Equipment Financing in Dallas, TX",
    "secondaryKeywords": [
      "manufacturing loans",
      "manufacturing lending",
      "manufacturing business loans",
      "loans for manufacturing business",
      "manufacturing equipment leasing",
      "loan manufacturing",
      "manufacturing equipment loans",
      "food manufacturing equipment finance"
    ],
    "faqQuestions": [],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 13,
    "natVol": 500,
    "cpc": 37.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/agriculture-equipment-financing/",
    "slug": "agriculture-equipment-financing",
    "pillar": "Agriculture Equipment Financing",
    "primaryKeyword": "agriculture equipment financing dallas",
    "h1": "Agriculture Equipment Financing in Dallas, TX",
    "secondaryKeywords": [
      "agriculture land loans",
      "agriculture business loans",
      "business loan for agriculture",
      "agriculture lending",
      "agriculture land purchase loan",
      "agriculture loans rates",
      "agriculture home loan",
      "agriculture house loan"
    ],
    "faqQuestions": [
      "small business loans for agriculture",
      "agriculture small business loans",
      "farmer agriculture loan",
      "bank loan for agriculture",
      "agriculture equipment finance companies",
      "agriculture tractor loan"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 63,
    "natVol": 5000,
    "cpc": 15.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/landscaping-equipment-financing/",
    "slug": "landscaping-equipment-financing",
    "pillar": "Landscaping Equipment Financing",
    "primaryKeyword": "landscaping equipment financing dallas",
    "h1": "Landscaping Equipment Financing in Dallas, TX",
    "secondaryKeywords": [
      "landscaping business loans",
      "small business loan for landscaping",
      "landscaping equipment loan"
    ],
    "faqQuestions": [],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 4,
    "natVol": 500,
    "cpc": 21.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/farm-credit-financing/",
    "slug": "farm-credit-financing",
    "pillar": "Farm Credit Financing",
    "primaryKeyword": "farm credit financing dallas",
    "h1": "Farm Credit Financing in Dallas, TX",
    "secondaryKeywords": [
      "farm machinery finance",
      "farm ownership loan",
      "farm loans",
      "farm land loans",
      "farm credit loans",
      "farm credit lenders",
      "farm credit farm loans",
      "farm loan calculator"
    ],
    "faqQuestions": [
      "farm financing",
      "state farm home loan",
      "state farm mortgage loans",
      "state farm mortgages",
      "state farm home mortgage",
      "state farm mortgage company"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 439,
    "natVol": 50000,
    "cpc": 4.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/sba-loan-for-daycare/",
    "slug": "sba-loan-for-daycare",
    "pillar": "Sba Loan For Daycare",
    "primaryKeyword": "sba loan for daycare dallas",
    "h1": "Sba Loan For Daycare in Dallas, TX",
    "secondaryKeywords": [
      "daycare business loans",
      "daycare loan",
      "business loan for daycare center",
      "business loan for home daycare",
      "how to get a business loan for a daycare",
      "how to get a small business loan for a daycare",
      "sba loans for daycare centers",
      "daycare ppp loan"
    ],
    "faqQuestions": [],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 11,
    "natVol": 500,
    "cpc": 8.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/sba-loan-for-franchise/",
    "slug": "sba-loan-for-franchise",
    "pillar": "Sba Loan For Franchise",
    "primaryKeyword": "sba loan for franchise dallas",
    "h1": "Sba Loan For Franchise in Dallas, TX",
    "secondaryKeywords": [
      "sba franchise financing",
      "franchise loans sba",
      "sba franchise lenders",
      "sba franchise registry",
      "franchise loans",
      "franchise lending",
      "loan franchise",
      "lending franchise"
    ],
    "faqQuestions": [
      "franchise financing options",
      "financial franchise business",
      "franchise business finance",
      "business loan to buy a franchise",
      "sba loan for franchise purchase",
      "business loan to start a franchise"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 140,
    "natVol": 5000,
    "cpc": 12.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/sba-express-loan-for-veterans/",
    "slug": "sba-express-loan-for-veterans",
    "pillar": "Sba Express Loan For Veterans",
    "primaryKeyword": "sba express loan for veterans dallas",
    "h1": "Sba Express Loan For Veterans in Dallas, TX",
    "secondaryKeywords": [
      "sba express lenders",
      "sba express loan for veterans",
      "sba veterans advantage program",
      "sba loans for veterans",
      "small business loans for veterans",
      "small business financing for veterans",
      "veterans affairs small business loan",
      "business loan express"
    ],
    "faqQuestions": [
      "sba express loan program",
      "sba veterans advantage",
      "sba express loan requirements",
      "sba express loan qualifications",
      "sba loan programs for veterans",
      "sba veterans advantage loan"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 210,
    "natVol": 5000,
    "cpc": 15.0
  },
  {
    "pageType": "Vertical Pillar",
    "url": "/dallas/women-owned-business-funding/",
    "slug": "women-owned-business-funding",
    "pillar": "Women Owned Business Funding",
    "primaryKeyword": "women owned business funding dallas",
    "h1": "Women Owned Business Funding in Dallas, TX",
    "secondaryKeywords": [
      "small business loans for women",
      "women's small business loans",
      "women owned business funding",
      "funds for women owned businesses",
      "female owned business loans",
      "women owned business loans",
      "business loans for women owned businesses",
      "women owned small business loans"
    ],
    "faqQuestions": [
      "business loans for women and minorities",
      "women's business loans from the government",
      "women's business loans government",
      "micro loans women",
      "best business loans for women",
      "business loans for black owned businesses"
    ],
    "lane": "Organic",
    "schema": [
      "Service",
      "FAQPage"
    ],
    "clusterSize": 66,
    "natVol": 5000,
    "cpc": 7.0
  }
];

export const dallasHome = dallasPages.find((p) => p.pageType === "Home")!;
export const dallasHub = dallasPages.find((p) => p.pageType === "City Hub")!;
export const dallasMoneyPillars = dallasPages.filter((p) => p.pageType === "Money Pillar");
export const dallasIndustryPillars = dallasPages.filter((p) => p.pageType === "Vertical Pillar");
export const dallasPillars = [...dallasMoneyPillars, ...dallasIndustryPillars];
export const getDallasPillar = (slug: string) => dallasPillars.find((p) => p.slug === slug);